import React from 'react';
import { Badge } from '@material-ui/core';
import CloseButton from './CloseButton';

export default function CloseBadge({ children, onClose }: { children: JSX.Element; onClose: () => void }) {
    return <Badge badgeContent={<CloseButton onClose={onClose} />}>{children}</Badge>;
}
